<template>
  <div class="member-service">
    <div class="aboutDlabel_content">
      <p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">隱私政策</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">&nbsp;</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">我們的隱私政策將於</span><span style=";font-family:思源黑体;font-size:14px">2021 年 </span><span style=";font-family:思源黑体;font-size:14px">12</span><span style=";font-family:思源黑体;font-size:14px">&nbsp;<span style="font-family:思源黑体">月</span> </span><span style=";font-family:思源黑体;font-size:14px">03</span><span style=";font-family:思源黑体;font-size:14px">&nbsp;<span style="font-family:思源黑体">日</span></span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">生效。自該日起，本隱私政策可以提供有關我們如何管理您的</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">雲聯</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">產品和服務的個人信息的隱私詳情。請花點時間熟悉我們的隱私政策，如果您有任何問題，請告訴我們。</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">&nbsp;</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <strong><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">我們對您的承諾</span></strong>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">您的隱私對我們非常重要。本隱私政策是一項涵蓋</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">雲聯</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">應用隱私方面的聲明和承諾，是</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">雲聯</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">隱私政策不可分割的一部分，我們建議您仔細閱讀</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">雲聯</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">隱私政策。</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">最終，我們希望為我們的用戶提供最好的體驗。如果您對本隱私政策中所述的我們的數據處理做法有任何疑問，請與我們聯繫，以便我們能夠回應您的具體問題。我們很樂意收到您的任何反饋。</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">&nbsp;</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <strong><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">一、</span></strong><strong><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">關於數據存儲</span></strong>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">本應用可在非聯網的狀態下使用，不和雲端有任何數據交互，關於應用的圖片、保存的標籤會儲存在用戶的手機中，若刪除應用，保存的標籤數據會一併刪除，將無法找回。因刪除應用造成保存的標籤數據丟失，我們不承擔此責任。</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">&nbsp;</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <strong><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">二、獲取的權限</span></strong>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px"><span style="font-family:思源黑体">為提供基本服務，本應用需要向您申請以下權限，保證</span>APP正常運行：</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">（一）手機儲存權限</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px"><span style="font-family:思源黑体">此權限允許</span>APP將數據存入或讀取，以保證基礎功能的使用，如緩存個性字體、標籤文件。</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">（二）</span><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">相機權限</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px"><span style="font-family:思源黑体">此權限允許</span>APP訪問相機，以正常使用掃一掃功能，便於提取條形碼和二維碼，提升工作效率。</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">&nbsp;</span>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <strong><span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">三、聯繫我們</span></strong>
</p>
<p style="margin-top:0;margin-bottom:0;margin-left:0;text-indent:0;text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px"><span style="font-family:思源黑体">如果您對本隱私政策有任何問題或反饋，或者您對我們如何收集、使用或披露您的個人信息有任何疑問，請與我們聯繫支持並提及您的信息涉及</span>“隱私政策”。我們專門的響應團隊將能夠處理您可能遇到的有關權利請求。如果您有需要解決的特別關鍵的問題，我們可能會要求您向我們提供更多信息。</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px"><span style="font-family:思源黑体">郵箱：</span>yunlian601@gmail.com</span>
</p>
<p>
    <span style=";font-family:思源黑体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style="font-family: 思源黑体;letter-spacing: 0;font-size: 14px">雲聯</span>
</p>
<p>
    <br/>
</p>
    </div>
  </div>
</template>

<script>
export default {
  created() {
      
    document.querySelector('title').innerHTML = '隱私政策'
    setTimeout(() => {
      document.body.scrollTop = 0;
    }, 0);
  },
};
</script>

<style lang="scss" scoped>
.member-service {
  padding: 0.4rem 0.4rem;
}
</style>